import { useMemo } from "react";
import React, { Platform } from "react-native";
import { Tooltip } from "react-native-paper";
import { useTheme } from "../../theme";
import { Icon, IconProps } from "../icon";

export function TooltipIcon({
    title,
    color,
    icon = "info",
    size = "small",
    style,
}: {
    title: string;
    color?: IconProps["color"];
    icon?: IconProps["name"];
    size?: IconProps["size"];
    style?: IconProps["style"];
}) {
    const theme = useTheme();

    const iconStyle = useMemo(
        () => [
            {
                paddingHorizontal: theme.spacingScale,
                color: !color ? theme.colors.primary : color,
            },
            style,
        ],
        [color, style, theme.colors.primary, theme.spacingScale]
    );

    return (
        <Tooltip
            title={title}
            leaveTouchDelay={Platform.OS === "web" ? 0 : 1500}
        >
            <Icon name={icon} size={size} style={iconStyle} />
        </Tooltip>
    );
}
